// import Card from "../components/ui/Card.js"
// import classes from './GameBlog.module.css';
import { useState, useEffect } from 'react';
import GameBlogPostList from '../components/gameblog/GameBlogPostList.js';
// import GameBlogPost from '../components/gameblog/GameBlogPost';

// const DUMMY_DATA = [
//     {
//     id: 'post1',
//         update: [
//             "Scene transitions are now handled by index rather than title.",
//             "Players are now added to a list and the solar then checks the list to find a player to target.",

//         ],
//     image:
//     'https://giphy.com/embed/ZqiLAVj3Bnwkue8YoE',
//     },
// ];


function GameBlogPage() {
    const [isLoading, setIsLoading] = useState(true); //returns an array with two elements, element 1 is current state snapshot and 2nd is a function for updating the state
    const [loadedGameBlogPosts, setLoadedGameBlogPosts] = useState([]);


    useEffect(() => {
        setIsLoading(true);
        //excuted only under certain circumstances, when the 2nd argument has changed
        // fetch('https://react-getting-started-b876f-default-rtdb.firebaseio.com/meetups.json'

        //fetch defaults to a get request, and returns a promise

        const fireBaseAuth = process.env.REACT_APP_apiKey;
        const payLoadToken = process.env.REACT_APP_payloadToken;
        // const fireBaseAuth = '?auth=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhZG1pbiI6dHJ1ZSwiZXhwIjoxNjY2NjI1NjY0LCJpYXQiOjE2NjY2MjIwNjQsInYiOjB9.ry5iNps4ZyBteuBVdTW8yIHwXPCgeO3Ypgfk79N4ja0&download=gamedevblog-fb536-default-rtdb-export.json&format=export&print=pretty&authuser=0';
        const myLank = `https://gamedevblog-fb536-default-rtdb.firebaseio.com/.json${fireBaseAuth}`
        // const fireBaseUid = payLoadToken;
        const authPayload = {
            "uid": payLoadToken,
            "token": {
                "sub": payLoadToken,
                "authFields": {
                "email": "",
                "email_verified": false,
                "phone_number": "",
                "name": ""
                },
                "firebase": {
                "sign_in_provider": "google.com"
                }
            }
        }

        fetch(myLank, authPayload).then(response => {
            console.log(response);
            return response.json(); //json also returns a promise as well so.. it has to be returned/resolved first
        }).then(data => {
            //we want to extract an array of meetups and then pass to meetup list
            const GameBlogPosts = [];
            for (const key in data) {
                console.log("data: " + key.date)
                let blogpost = {
                    id: key,
                    ...data[key]
                    // ... is called the spread operator (default js), copies all key value pairs
                };
                // let newBlogPost = {}
                let temp = {}
                try{
                    if (!blogpost["date"]){
                        for(var x_key in blogpost ){
                            if(x_key !== "id"){
                                temp = JSON.parse(blogpost[x_key])
                            }
                            console.log("temp | " + temp)
                        }
                    }
                }catch(e){
                    console.log("Error: " + e.message);
                }

                GameBlogPosts.push(blogpost);
            }
            console.log(GameBlogPosts)
            setIsLoading(false);
            setLoadedGameBlogPosts(GameBlogPosts);
        });
    }, []);
    console.log("BLOG POSTS:")
    console.log("%j", loadedGameBlogPosts)
    console.log("|||||||||||||||||||||||||")

    //arg 1 is a function , 2nd arg is an array of external dependancies
    //this code will only run once when the page is rendered for the first time, because there are no external dependancies
    if (isLoading) {
        return ( <section >
            <p> Loading... </p> </section>
        );
    }
    return ( < GameBlogPostList GameBlogPost = { loadedGameBlogPosts }
        />);
    }

    // function AllMeetupsPage() {



    //     if (isLoading) {
    //         return (
    //             <section>
    //                 <p>Loading...</p>
    //             </section>
    //         );
    //     }

    //     return <section>
    //         <h1>All Meetups Page</h1>
    //         <MeetupList />
    //         </section>;
    // }

    export default GameBlogPage;